import { makeStyles } from 'tss-react/mui';
import React from 'react';

export type DLProps = {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
};

export const DL: React.FC<DLProps> = ({ children, className }) => {
  const { classes, cx } = useDLStyles();

  return (
    <dl className={cx(classes.dl, className)}>
      {children}
    </dl>
  );
};

export type DLItemProps = {
  t: React.ReactNode;
  d: React.ReactNode;
  className?: string;
};

export const DLItem: React.VFC<DLItemProps> = ({ t, d, className }) => {
  const { classes } = useDLStyles();

  return (
    <div className={className}>
      <dt className={classes.dt}>{t}</dt>
      <dd className={classes.dd}>{d}</dd>
    </div>
  );
};


const useDLStyles = makeStyles()({
  dl: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      display: 'flex'
    },
  },
  dt: {
    fontWeight: 500,
    '&::after': {
      content: '": "'
    }
  },
  dd: {
    margin: '0 4px'
  }
});
